<template>
  <div style="background-color: #fff">
    <Header />
    <main id="main-content" tabindex="-1">
      <div id="dispFlex">
        <div id="width-cont">
          <h1>Pass Help</h1>
          <div id="side-by-side">
            <div class="down">
              <!-- <div
                class="box-cont"
                @click="redirect('passhelp/stickerlanding')"
              >
                <div class="img-cont">
                  <img src="../assets/icons/sticker-mockup.svg" alt="" />
                </div>
                <h2>Receive My Annual Pass Sticker</h2>
              </div> -->
              <div class="box-cont" @click="link('2026')">
                <div class="img-cont">
                  <img src="../assets/icons/2026-pass.svg" alt="" />
                </div>
                <h2>How To Register My 2026 Annual Pass</h2>
              </div>
              <div class="box-cont" @click="link('2025')">
                <div class="img-cont">
                  <img src="../assets/icons/2025-pass.svg" alt="" />
                </div>
                <h2>How To Register My 2025 Annual Pass</h2>
              </div>
            </div>
            <div class="down">
              <div class="box-cont" @click="redirect('plateupdate')">
                <div class="img-cont">
                  <img src="../assets/icons/license-mockup.svg" alt="" />
                </div>
                <h2>Change License Plate Info</h2>
              </div>
              <div class="box-cont" @click="redirect('parks/PANUAL/dayuse')">
                <div class="img-cont">
                  <img src="../assets/icons/shopping-cart.svg" alt="" />
                </div>
                <h2>Purchase a New Annual Pass</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="bottom-left">
        <h3>Talk With Us</h3>
        <div id="spacer"></div>
        <div id="side-flex">
          <img src="../assets/new_icons/call.svg" alt="" />
          <h4>888-492-1896</h4>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "PassHelp",
  // Add your component logic here
  metaInfo: {
    title: "Pass Help",
    meta: [
      {
        name: "description",
        content: "Help with your Utah State Park Pass",
      },
    ],
  },
  components: {
    // Add your components here
    Header,
  },
  data() {
    return {
      // Add your data here
    };
  },
  mounted() {
    // Check if the script is already loaded
    if (!document.getElementById("ze-snippet")) {
      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src =
        "https://static.zdassets.com/ekr/snippet.js?key=51bc2338-edfd-4f18-ab25-68ba29111a5d";
      script.async = true;
      document.body.appendChild(script);
    }
  },
  beforeUnmount() {
    // Remove the script when leaving the page
    const snippet = document.getElementById("ze-snippet");
    if (snippet) snippet.remove();
  },
  methods: {
    redirect(x) {
      // Add your redirect logic here
      this.$router.push("/" + x);
    },
    link(year) {
      if (year == "2026") {
        window.open(
          "https://parkspass.zendesk.com/hc/en-us/articles/43409224589339-Registering-Your-2026-Annual-Pass"
        );
      } else {
        window.open(
          "https://parkspass.zendesk.com/hc/en-us/articles/24050131601179-Registering-Utah-State-Park-Annual-Passes"
        );
      }
    },
    // Add your methods here
  },
};
</script>

<style scoped>
.img-cont {
  width: 130px;
  display: flex;
}
#side-by-side {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.down {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 48%;
}
h1 {
  color: #494e53;
  text-align: center;
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
  margin-bottom: 30px;
}
h3 {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
h4 {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
#side-flex {
  display: flex;
  align-items: center;
}
#side-flex > img {
  margin-right: 5px;
}
#bottom-left {
  width: 186px;
  padding: 50px 25px 25px 25px;
}
#spacer {
  height: 1px;
  background-color: #9c9c9c;
  margin: 12px 0px;
}
#dispFlex {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
#width-cont {
  display: flex;
  width: 80%;
  max-width: 900px;
  flex-direction: column;
  align-items: flex-start;
}
.box-cont {
  border-radius: 4px;
  background: #f5f5f5;
  border: 1px solid #96a145;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  margin-bottom: 20px;
  display: flex;
  padding: 15px 20px;
  align-items: center;
  height: 104px;
}
h2 {
  color: #000;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */
  margin-left: 20px;
}
#box-grid {
  width: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 425px) {
  .box-cont {
    padding: 8px;
  }
  #box-grid {
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
  }
  h2 {
    padding: 0px;
  }
  h1 {
    font-size: 32px;
    margin-bottom: 20px;
  }
  #dispFlex {
    margin-top: 30px;
  }
  #side-by-side {
    flex-direction: column;
    gap: 20px;
  }
  .down {
    width: 100%;
  }
  .box-cont {
    width: 100%;
  }
  .img-cont {
    width: 115px;
  }
  .img-cont > img {
    width: 100%;
  }
}
</style>
